<template>
  <div id="app">
    <!-- <router-view name="header"></router-view> -->
        <main>
          <AppBody />
        </main>
    <!-- <router-view name="footer"></router-view> -->
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppBody from './components/AppBody.vue'
import AppFooter from './components/AppFooter.vue'

export default {
  name: 'app',
  components: {
    AppHeader,
    AppBody,
    AppFooter
  }
}
</script>

<style>
  body {
    height: 100vh;
    width: 100vw;
  }
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
